import React from 'react';
import styles from './Input.module.scss';

export const Input = React.forwardRef(({ label, error, className = '', inputRef, ...props }, ref) => {
  const resolvedRef = ref || inputRef;
  return (
    <div className={styles.wrapper}>
      {label && <label className={styles.label}>{label}</label>}
      <input ref={resolvedRef} className={`${styles.input} ${error ? styles.hasError : ''} ${className}`} {...props} />
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
});
Input.displayName = 'Input';

export const OTPInput = ({ value = [], onChange, inputsRef, length = 4, idPrefix = 'otp' }) => {
  const handleChange = (index, val) => {
    if (!/^[0-9]?$/.test(val)) return;
    const next = [...value];
    next[index] = val;
    if (onChange) onChange(next, index);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !value[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  return (
    <div className={styles.otpContainer}>
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          id={`${idPrefix}-${index}`}
          maxLength={1}
          className={`${styles.input} ${styles.otpInput}`}
          value={value[index] || ''}
          ref={(el) => (inputsRef.current[index] = el)}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(e, index)}
        />
      ))}
    </div>
  );
};

export default Input;
